export const brandValues = [
  {
    icon: "ri-focus-3-line",
    title: "只做整理，不做定性",
    desc: "我们把分散的公开信息按话题归拢，标注时间与来源方向，把判断留给读者自己。",
  },
  {
    icon: "ri-time-line",
    title: "时间线优先",
    desc: "每个合集都以时间线为骨架，先讲清楚先后顺序，再补充细节，避免张冠李戴。",
  },
  {
    icon: "ri-shield-check-line",
    title: "可核对、可纠正",
    desc: "内容保留可查证的线索；收到反馈后我们会核实并更新，页面上标注最近修改时间。",
  },
  {
    icon: "ri-user-heart-line",
    title: "不消费当事人",
    desc: "不发布未经证实的私人信息，不使用耸动标题引导情绪，把注意力放在事件本身。",
  },
];

export const testimonials = [
  {
    name: "阿哲",
    role: "长期关注热点",
    text: "以前追一个瓜要翻十几个帖子，现在打开一个合集就能看到前因后果，时间线特别省事。",
  },
  {
    name: "小满",
    role: "内容从业者",
    text: "做选题时会先来这边看话题脉络，信息按时间排好，比自己从零整理快太多了。",
  },
  {
    name: "老鹿",
    role: "普通读者",
    text: "最喜欢的是它不喊口号，把事情讲清楚就收住，看得很舒服。",
  },
];

export const milestones = [
  { year: "2023", text: "从一个小型话题整理项目开始，最初只服务几十位固定读者。" },
  { year: "2024", text: "上线合集与时间线功能，把零散信息结构化，收录话题突破一千个。" },
  { year: "2025", text: "完善分类与搜索，建立内容核对流程，形成稳定的更新节奏。" },
  { year: "2026", text: "持续优化阅读体验，推出「只看新增」的更新提示方式。" },
];